<template>
  <div class="app flex-row align-items-center login">
    <div class="container">
      <v-row class="justify-content-center">
        <v-col md="8">
          <b-card-group v-if="card == 'employee'">
            <b-card no-body class="pa-sm-4 pa-2 cardColor">
              <b-card-body>
                <b-form>
                  <p class="text-center font-4xl text-dark">خوش آمدید!</p>
                  <p class="text-muted text-center">
                    وارد حساب کاربری خود شوید
                  </p>

                  <v-text-field
                    type="text"
                    v-model="username"
                    label="نام کاربری"
                    outlined
                    dense
                    append-icon="mdi-account"
                  />

                  <v-text-field
                    type="password"
                    v-model="password"
                    label="رمز ورود"
                    outlined
                    dense
                    @keyup.enter="password && username ? login() : ''"
                    append-icon="mdi-lock"
                  />
                  <div class="d-flex justify-center mb-6">
                    <v-btn
                      color="primary"
                      @click="login()"
                      :disabled="!username || !password"
                      block
                      :loading="busy"
                    >
                      <v-icon dark> mdi-login-variant </v-icon>ورود
                    </v-btn>
                  </div>
                  <span class="ps-2"
                    >اگر مشتری هستید از این قسمت وارد شوید</span
                  >
                  <br class="d-block d-sm-none" />
                  <span @click="card = 'customer'" class="underLines ms-3"
                    >ورود مشتری</span
                  >
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
          <b-card-group v-if="card == 'customer'">
            <b-card no-body class="pa-sm-4 pa-2 cardColor">
              <b-card-body>
                <p class="text-center font-4xl text-dark">خوش آمدید!</p>
                <p class="text-muted text-center">
                  لطفا برای ورود به سیستم و دریافت رمز عبور یکبار مصرف از طریق
                  پیامک، <b>شماره موبایل</b> خود را وارد کنید.
                </p>

                <v-text-field
                  type="number"
                  v-model="mobile"
                  label="شماره موبایل"
                  outlined
                  dense
                  :loading="busy"
                  @keypress.enter.native="mobile ? sendCode() : ''"
                  append-icon="mdi-cellphone"
                />

                <div class="d-flex justify-center mb-6">
                  <v-btn
                    color="primary"
                    @click="sendCode()"
                    :disabled="!mobile"
                    block
                    :loading="busy"
                    >ارسال کد فعالسازی
                  </v-btn>
                </div>
                <span @click="card = 'employee'" class="underLines"
                  >ورود کاربران</span
                >
              </b-card-body>
            </b-card>
          </b-card-group>
          <b-card-group v-if="card == 'activationCode'">
            <b-card no-body class="pa-sm-4 pa-2 cardColor">
              <b-card-body>
                <b-form>
                  <p class="text-center">
                    کد ارسال شده از طریق پیامک را وارد کنید.
                  </p>
                  <p class="text-muted text-center">
                    کد تایید به شماره {{ mobile }} ارسال شده است
                  </p>

                  <div class="text-center mb-5">
                    <PincodeInput
                      v-model="code"
                      :class="incorrectCode ? 'incorrect-code' : ''"
                      @input="loginWithCode()"
                      :length="5"
                      :disabled="busy"
                    />
                  </div>
                  <v-row class="fs-small grey--text text--darken-2 mb-4">
                    <v-col cols="" class="text-center">
                      <span>کد را دریافت نکردید؟</span>
                    </v-col>
                    <v-col class="text-center">
                      <span v-if="countdown != 0">{{
                        toHHMMSS(countdown) + " تا ارسال دوباره"
                      }}</span>
                      <span
                        v-else
                        @click="sendCode()"
                        class="text-decoration-underline pointer"
                        color="primary"
                      >
                        ارسال دوباره
                      </span>
                    </v-col>
                  </v-row>
                  <div class="d-flex justify-center mb-6">
                    <v-btn
                      color="primary"
                      @click="
                        card = 'customer';
                        countdown = 0;
                      "
                      block
                      >ویرایش شماره موبایل
                    </v-btn>
                  </div>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import md5 from "js-md5";
import PincodeInput from "vue-pincode-input";
import crypto from "crypto";

export default {
  components: {
    PincodeInput,
  },
  data() {
    return {
      username: "",
      password: "",
      mobile: null,
      role: "",
      code: "",
      incorrectCode: false,
      card: "employee",
      countdown: 60,
      busy: false,
    };
  },
  methods: {
    login() {
      this.busy = true;
      Axios.post(this.baseUrl + "/ppkpms/auth/login", {
        username: this.username,
        password: md5(this.password),
      })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            localStorage.clear();
            localStorage.setItem("token", res.data.token);
            localStorage.setItem("role", res.data.role);
            localStorage.setItem("name", res.data.name);
            localStorage.setItem("userId", res.data.id);
            localStorage.setItem("userType", "User");
            if (this.$route.query.return) {
              this.$router.push(this.$route.query.return);
            }
            if (res.data.role == "factory") {
              this.$router.push("/" + res.data.role + "/productionDashboard");
            } else {
              this.$router.push("/" + res.data.role + "/dashboard");
            }
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },

    sendCode() {
      this.busy = true;
      this.incorrectCode = false;
      this.code = "";
      Axios.post(this.baseUrl + "/ppkpms/auth/agentLogin", {
        mobile: this.mobile,
      })
        .then((res) => {
          this.busy = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.card = "activationCode";
            this.countdown = 60;
            this.countDownTimer();
          } else {
            this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          this.busy = false;
          this.toast(err.response.data, "error");
        });
    },

    loginWithCode() {
      if (this.code.length == 5) {
        this.busy = true;
        Axios.post(this.baseUrl + "/ppkpms/auth/agentEntrance", {
          mobile: this.mobile,
          activationCode: this.code,
        })
          .then((res) => {
            this.busy = false;
            if (res.status == 200) {
              this.incorrectCode = false;
              localStorage.clear();
              localStorage.setItem("token", res.data.token);
              localStorage.setItem("role", res.data.role);
              localStorage.setItem("name", res.data.name);
              localStorage.setItem("userId", res.data.contactId);
              localStorage.setItem("userType", "Contact");
              this.$router.push("/allChats");
            } else {
              this.toast("خطایی رخ داده است. مجددا امتحان کنید.", "error");
            }
          })
          .catch((err) => {
            if (err.response && err.response.status == 409) {
              this.incorrectCode = true;
            }
            this.busy = false;
            this.toast(err.response.data, "error");
          });
      }
    },

    countDownTimer() {
      //NOTE (m-countDownTimer) to start counting down after 1 second

      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.countdown = 0;
      }
    },
    toHHMMSS(value) {
      // NOTE (m-toHHMMSS) determine the order of hours, minutes and seconds
      var sec_num = parseInt(value, 10); // don't forget the second param
      var hours = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - hours * 3600) / 60);
      var seconds = sec_num - hours * 3600 - minutes * 60;

      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return minutes + ":" + seconds;
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
.login {
  .container {
    width: 70%;
    @media only screen and (max-width: 600px) {
      width: 97% !important;
    }
  }
}
.vue-pincode-input-wrapper {
  direction: ltr !important;
  .vue-pincode-input {
    max-width: 60px !important;
    height: 60px;
    margin: 18px;
  }
  @media only screen and (max-width: 600px) {
    .vue-pincode-input {
      max-width: 40px !important;
      height: 40px;
      margin: 4px !important;
    }
  }
}
.incorrect-code {
  .vue-pincode-input {
    max-width: 60px !important;
    height: 60px;
    margin: 18px;
    border: solid 1px #9f2017 !important;
    background-color: rgba(159, 32, 23, 0.12) !important;
    box-shadow: none !important;
  }
  @media only screen and (max-width: 600px) {
    .vue-pincode-input {
      max-width: 40px !important;
      height: 40px;
      margin: 4px !important;
    }
  }
}
</style>
<style scoped>
.cardColor {
  border: 0px;
  border-radius: 59px;
  background: rgb(232, 240, 254);
  box-shadow: 30px 30px 61px #b6bdde, -30px -30px 61px #e4ebff;
}
.app {
  background-color: #f0f3ff;
}

.underLines {
  cursor: pointer;
  font-size: 14px;
  color: #6092cd !important;
  border-bottom: #6092cd 1px solid;
}
</style>
